import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom/cjs/react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import AsyncSelectField from "../../Components/Common/AsyncSelectField";

import { useFormik } from "formik";
import { registerPlugin } from "react-filepond";
import { useHistory, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import { object, string } from "yup";

import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import "filepond/dist/filepond.min.css";
import Loader from "../../Components/Common/Loader";
import {
  useUserCategory,
  useUserTypes,
  useUpdateUserCategory,
} from "../../hooks/useUserCategories";

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

const UpdateCategories = (props) => {
  document.title =
    "Modifier une catégorie d'institutions | Le Conseiller du BTP";

  const history = useHistory();
  const id = useParams().id;

  const categoryQ = useUserCategory(id);
  const category = categoryQ.data || {};
  const userTypesQ = useUserTypes();
  const userTypes = userTypesQ.data || [];
  const updateMutation = useUpdateUserCategory();

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      designation: category.name || "",
      user_type_id: category.user_type?.id
        ? String(category.user_type.id)
        : "",
    },

    validationSchema: object().shape({
      designation: string().required(
        props.t("Entrer la désignation de la catégorie"),
      ),
      user_type_id: string().required(
        props.t("Choisissez le type d'utilisateur"),
      ),
    }),

    onSubmit: async (values) => {
      const payload = {
        name: values.designation,
        user_type_id: Number(values.user_type_id),
      };

      try {
        await updateMutation.mutateAsync({ id, payload });
        validation.resetForm();
        history.push("/utilisateurs-categories");
      } catch (_) {
        // handled by toast in hook
      }
    },
  });

  // Wait for the user types too: with `enableReinitialize`, if the category
  // resolves first the matching <option> does not exist yet, the browser falls
  // back to the placeholder and Formik never re-runs — the form then opens
  // with no user type selected.
  if (categoryQ.isLoading || userTypesQ.isLoading) return <Loader />;

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title={props.t("Modifier une catégorie d'institutions")}
          pageTitle={props.t("Utilisateurs")}
        />

        <Row>
          <Col lg={12}>
            <Form
              encType="multipart/form-data"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
              }}
            >
              <Card>
                <CardBody>
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="designation">
                      {props.t("Désignation de la catégorie")}
                    </Label>
                    <Input
                      type="text"
                      className="form"
                      placeholder={props.t("Entrer la désignation")}
                      name="designation"
                      value={validation.values.designation}
                      onBlur={validation.handleBlur}
                      onChange={validation.handleChange}
                      required
                    />
                    {validation.errors.designation &&
                    validation.touched.designation ? (
                      <FormFeedback type="invalid">
                        {validation.errors.designation}
                      </FormFeedback>
                    ) : null}
                  </div>

                  <Row>
                    <Col xl={12}>
                      <AsyncSelectField
                        label={props.t("Type d'utilisateur")}
                        name="user_type_id"
                        value={validation.values.user_type_id}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        options={userTypes}
                        optionLabelKey="label"
                        placeholder={props.t(
                          "Sélectionner le type d'utilisateur"
                        )}
                        required
                        isLoading={userTypesQ.isLoading}
                        isError={userTypesQ.isError}
                        onRetry={userTypesQ.refetch}
                        errorText={props.t(
                          "Impossible de charger les types d'utilisateurs."
                        )}
                        invalid={Boolean(
                          validation.errors.user_type_id &&
                            validation.touched.user_type_id
                        )}
                        feedback={validation.errors.user_type_id}
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <div className="text-end mb-3">
                <Link to="/utilisateurs-categories" className="btn btn-primary me-2">
                  {props.t("Retour")}
                </Link>
                <button
                  type="submit"
                  className="btn btn-warning w-sm m-2"
                  disabled={updateMutation.isPending}
                >
                  {updateMutation.isPending && (
                    <Spinner size="sm" className="me-2" />
                  )}
                  {props.t("Modifier")}
                </button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

UpdateCategories.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(UpdateCategories));
